import type { HeaderGroup } from "@tanstack/react-table";
import { cn } from "../../lib/utils";
import { DynamicDataTableHeaderCell } from "./DynamicDataTableHeaderCell";

type DynamicDataTableHeaderProps<TData> = {
	headerGroups: HeaderGroup<TData>[];
	className?: string;
	onDoubleClick?: () => void;
};

export const DynamicDataTableHeader = <TData,>({
	headerGroups,
	className,
	onDoubleClick,
}: DynamicDataTableHeaderProps<TData>) => (
	<div
		className={cn(
			"sticky z-20 top-0 left-0 right-0 h-[33px] min-w-fit flex bg-surface-neutral border-b border-bc-default select-none",
			className,
		)}
		onDoubleClick={onDoubleClick}
		title={
			onDoubleClick
				? "Double-click to fit columns to the view (resizable columns share width in proportion to defaults)"
				: undefined
		}
	>
		{headerGroups.map((headerGroup) =>
			headerGroup.headers.map((header) => (
				<DynamicDataTableHeaderCell key={header.id} header={header} />
			)),
		)}
	</div>
);
